<header class="o-widget__header">
  <h1 class="o-widget__heading">{{ company?.name }}-Widget</h1>
  <p class="o-widget__subline">Wenn Berechtigung für das Unternehmen</p>
</header>
<div class="o-widget__body">
  <p>Gesamtstatus des Unternehmens</p>
  <p>Fortschritt in den Complinences > Absprung in Workspace > Filter auf den Bereich </p>
</div>
